export const skillData = {
  label: "WHAT SKILLS I BRING TO THE TABLE",

  sections: [
    {
      title: "Most Relevant",
      items: [
        "React",
        "Angular",
        "TypeScript",
        "JavaScript (ES6+)",
        "Tailwind CSS",
        "Figma",
        "Node.js",
        "Next.js",
        "UI Engineering",
      ],
    },
    {
      title: "Frontend Engineering",
      items: [
        "React",
        "Angular",
        "TypeScript",
        "JavaScript (ES6+)",
        "HTML5",
        "CSS3",
        "Tailwind CSS",
        "Material UI",
      ],
    },
    {
      title: "State, Backend & Data",
      items: [
        "Redux",
        "Context API",
        "RxJS",
        "Node.js",
        "Express.js",
        "PostgreSQL",
        "MongoDB",
      ],
    },
    {
      title: "Design & Prototyping",
      items: [
        "Figma",
        "Framer",
        "Adobe Illustrator",
        "UX/UI Design",
      ],
    },
    {
      title: "Tools & Platforms",
      items: ["Git", "Postman", "Jira", "WordPress", "Wix"],
    },
    {
      title: "Core Focus Areas",
      items: [
        "UI Engineering",
        "Component Architecture",
        "Performance Optimization",
        "Accessibility (a11y)",
        "Responsive Design",
      ],
    },
  ],
};
